<div class="container mx-auto px-4 py-8 prose prose-gray dark:prose-invert max-w-3xl">
  <h1>Terms of Service</h1>
  <p class="text-sm text-gray-500 dark:text-gray-400">Last updated: May 14, 2025</p>

  <p>
    Welcome to Summerry.com. These Terms of Service ("Terms") govern your access to and use of the website and services
    provided by Summerry. By accessing or using Summerry.com, you agree to be bound by these Terms. If you do not agree,
    please do not use the website.
  </p>

  <h2>1. About Summerry</h2>
  <p>
    Summerry provides AI-generated news digests focused on artificial intelligence and machine learning. The content is
    based on publicly available, trusted sources, and processed using automated systems.
  </p>

  <h2>2. Use of the Website</h2>
  <p>
    You may access and use Summerry.com for informational and personal purposes only. By using this website, you agree
    to:
  </p>
  <ul>
    <li>Use the website in a lawful and respectful manner.</li>
    <li>Not copy, redistribute, or republish any content without permission or attribution.</li>
    <li>Not attempt to gain unauthorized access to any part of the website or its infrastructure.</li>
  </ul>

  <h2>3. Intellectual Property</h2>
  <p>
    All content on Summerry.com, including text, summaries, logos, branding, layout, and software, is the intellectual
    property of Summerry unless stated otherwise.
  </p>

  <p>You may:</p>
  <ul>
    <li>Share our news summaries by linking to the original page.</li>
    <li>Quote short excerpts with proper attribution to Summerry.com.</li>
  </ul>

  <p>You may not:</p>
  <ul>
    <li>Copy, republish, or modify content for commercial use without written consent.</li>
    <li>Misrepresent or pass off our content as your own.</li>
  </ul>

  <h2>4. Newsletter Subscription</h2>
  <p>
    By subscribing to our newsletter, you agree to receive periodic email updates. You may unsubscribe at any time by
    clicking the link included in each email.
  </p>
  <p>
    We do not share your email address or subscription data with third parties. For more details, see our
    <a
      href="/privacy-policy"
      class="font-bold underline px-0 text-base text-gray-700 transition-colors hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-400"
      >Privacy Policy</a
    >.
  </p>

  <h2>5. Limitation of Liability</h2>
  <p>Summerry provides content "as is" and "as available". We make no warranties, express or implied, regarding:</p>
  <ul>
    <li>The completeness or accuracy of summaries or source materials.</li>
    <li>The availability or uninterrupted operation of the website.</li>
    <li>Any reliance you place on the content provided.</li>
  </ul>

  <p>You acknowledge that:</p>
  <ul>
    <li>AI-generated summaries may occasionally contain errors or omissions.</li>
    <li>The original source is always cited, and users are encouraged to verify information.</li>
  </ul>

  <p>Summerry is not liable for:</p>
  <ul>
    <li>Any direct or indirect damages arising from use or inability to use the website.</li>
    <li>Decisions made based on information presented in our summaries.</li>
  </ul>

  <h2>6. Changes to the Service</h2>
  <p>
    We reserve the right to modify, suspend, or discontinue any part of the website or newsletter at any time without
    notice. We may also update these Terms periodically. Continued use after changes indicates your acceptance of the
    revised Terms.
  </p>

  <p>The latest version will always be available at:</p>
  <p class="not-prose">
    <a
      href="/terms-of-service"
      class="underline px-0 text-base text-gray-900 transition-colors hover:text-gray-600 dark:text-gray-300 dark:hover:text-gray-400"
      >https://summerry.com/terms-of-service</a
    >
  </p>

  <h2>7. Governing Law</h2>
  <p>
    These Terms are governed by the laws of the Netherlands, without regard to conflict of law principles. Any disputes
    arising from these Terms shall be subject to the exclusive jurisdiction of the courts in the Netherlands.
  </p>

  <h2>8. Contact</h2>
  <p>If you have any questions about these Terms of Service, please contact us:</p>
  <p>
    Email:
    <a
      href="mailto:info.summerry@gmail.com"
      class="underline px-0 text-base text-gray-900 transition-colors hover:text-gray-600 dark:text-gray-300 dark:hover:text-gray-400"
      >info.summerry&#64;gmail.com</a
    >
  </p>
  <p>
    Website:
    <a
      href="/"
      class="underline px-0 text-base text-gray-900 transition-colors hover:text-gray-600 dark:text-gray-300 dark:hover:text-gray-400"
      >https://summerry.com</a
    >
  </p>
</div>
